/**
 * Parses plain-text notification bodies (membership, tournament, etc.)
 * into structured sections for the reading pane.
 */
export function parseNotificationMessage(raw) {
  const text = String(raw ?? "").trim();
  if (!text) return null;

  const lines = text.split(/\r?\n/).map((l) => l.trim());
  const nonEmpty = lines.filter(Boolean);

  if (nonEmpty.length === 0) return null;

  let greeting = null;
  const paragraphs = [];
  const details = [];
  let nextStep = null;
  let portalUrl = null;
  let closing = null;
  let inClosing = false;

  for (const line of nonEmpty) {
    if (!greeting && /^Dear .+/i.test(line)) {
      greeting = line.replace(/,\s*$/, "");
      continue;
    }

    if (/^Regards,?\s*$/i.test(line)) {
      inClosing = true;
      continue;
    }

    if (inClosing) {
      closing = closing ? `${closing} ${line}` : line;
      continue;
    }

    const portalMatch = line.match(/^Portal:\s*(https?:\/\/\S+)/i);
    if (portalMatch) {
      portalUrl = portalMatch[1];
      continue;
    }

    if (/^Next step:/i.test(line)) {
      nextStep = line.replace(/^Next step:\s*/i, "");
      continue;
    }

    const kvMatch = line.match(/^([A-Za-z][A-Za-z0-9 /-]{0,48}):\s*(.+)$/);
    if (kvMatch) {
      const label = kvMatch[1].trim();
      const value = kvMatch[2].trim();
      if (/^portal$/i.test(label)) {
        portalUrl = value;
      } else {
        details.push({ label, value });
      }
      continue;
    }

    paragraphs.push(line);
  }

  return {
    greeting,
    paragraphs,
    details,
    nextStep,
    portalUrl,
    closing: closing || "Giri Nestham",
    hasStructure:
      Boolean(greeting) ||
      details.length > 0 ||
      Boolean(nextStep) ||
      Boolean(portalUrl),
  };
}

export function notificationSubjectTone(subject) {
  const s = String(subject ?? "").toLowerCase();
  if (s.includes("approved") || s.includes("success") || s.includes("verified")) {
    return "success";
  }
  if (s.includes("reject") || s.includes("declined") || s.includes("failed")) {
    return "warning";
  }
  if (s.includes("pending") || s.includes("update")) {
    return "info";
  }
  return "default";
}
